import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { setUnauthorizedHandler } from './lib/api'
import { SessionProvider } from './lib/session'
import { ConfirmProvider } from './ui/confirm'
import { ToastProvider } from './ui/toast'
import { router } from './router'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
})
// Sessão expirada em qualquer chamada: confere o /auth/me, e o RequireAuth leva ao login guardando a página (next)
setUnauthorizedHandler(() => void queryClient.invalidateQueries({ queryKey: ['me'] }))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>
          <ConfirmProvider>
            <RouterProvider router={router} />
          </ConfirmProvider>
        </ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
)
